export const UserTableHeadings = [
  {
    title: "Name",
    classPrefix: "cell-min-",
    size: 220,
    sort: false
  },
  {
    title: "Email ID",
    classPrefix: "cell-min-",
    size: 250,
    sort: false
  },
  {
    title: "Total Filings",
    classPrefix: "cell-min-",
    size: 110,
    sort: false
  },
  {
    title: "Status",
    classPrefix: "cell-min-",
    size: 60,
    sort: false
  },
  {
    title: "Registered at",
    classPrefix: "cell-min-",
    size: 180,
    sort: false
  },
  /* {
    title: "Role",
    classPrefix: "cell-min-",
    size: 120,
    sort: false
  }, */
  {
    title: "",
    classPrefix: "cell-max-",
    size: 50,
    sort: false
  }
];

export const FilingTableHeadings = [
  {
    title: "Name & PAN",
    classPrefix: "cell-min-",
    size: 180,
    sort: false
  },
  {
    title: "Email",
    classPrefix: "cell-min-",
    size: 250,
    sort: false
  },
  {
    title: "Plan Name",
    classPrefix: "cell-min-",
    size: 180,
    sort: false
  },
  {
    title: "Tax Expert",
    classPrefix: "cell-min-",
    size: 160,
    sort: false
  },
  {
    title: "AY",
    classPrefix: "cell-min-",
    size: 80,
    sort: false
  },
  /* {
    title: "Payment Status",
    classPrefix: "cell-min-",
    size: 100,
    sort: false
  },
  {
    title: "Status",
    classPrefix: "cell-min-",
    size: 120,
    sort: false
  }, */
  {
    title: "Created at",
    classPrefix: "cell-min-",
    size: 180,
    sort: false
  },
  {
    title: "",
    classPrefix: "cell-max-",
    size: 50,
    sort: false
  }
];

export const TaxExpertTableHeadings = [
  {
    title: "Name",
    classPrefix: "cell-min-",
    size: 220,
    sort: false
  },
  {
    title: "Email ID",
    classPrefix: "cell-min-",
    size: 250,
    sort: false
  },
  {
    title: "Total Filings",
    classPrefix: "cell-min-",
    size: 110,
    sort: false
  },
  {
    title: "Status",
    classPrefix: "cell-min-",
    size: 60,
    sort: false
  },
  {
    title: "",
    classPrefix: "cell-max-",
    size: 50,
    sort: false
  }
];

export const AFPlansTableHeadings = [
  {
    title: "Name",
    classPrefix: "cell-min-",
    size: 220,
    sort: false
  },
  {
    title: "Status",
    classPrefix: "cell-min-",
    size: 80,
    sort: false
  },
  {
    title: "Price",
    classPrefix: "cell-min-",
    size: 120,
    sort: false
  },
  {
    title: "Action",
    classPrefix: "cell-min-",
    size: 120,
    sort: false
  },
  {
    title: "",
    classPrefix: "cell-max-",
    size: 50,
    sort: false
  }
];
